import { render, staticRenderFns } from "./FullNews.vue?vue&type=template&id=6aa9186c&scoped=true&"
import script from "./FullNews.vue?vue&type=script&lang=js&"
export * from "./FullNews.vue?vue&type=script&lang=js&"
import style0 from "./FullNews.vue?vue&type=style&index=0&id=6aa9186c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9186c",
  null
  
)

export default component.exports